<section class="main-section full-page-container ">
  <form #integrationNameForm="ngForm" class="step-form">
    <div>
      <div class="integrationHeading">
        <div class="details-navigation"
          routerLink="{{(editSourceBoolean) ? '/' + baseWord + '/integrations-list' : '/' + baseWord + '/datasources-listing'}}">
          <img class="backarrow" src="../assets/images/backarrow.svg"></div>
        <div class="details-navigation details-navigation-text">{{displayName + ' Integration'}}</div>
      </div>
      <div class="main-page-container dysteps">
        <div class="integration-container step-container">
          <div class="step-markers">
            <div class="step-markers-inner-wrapper">
              <span *ngFor="let stepNode of stepNodes; let i = index">
                <span class="{{stepNode}} marker-step"></span>
                <span *ngIf="!(i+1 === stepNodes.length)" class="{{stepLines[i]}} marker-line"></span>
              </span>
            </div>
          </div>
          <div>
            <div class="step-content">
              <div [hidden]="loader" class="step-wrapper">


                <div class="step-heading" [innerHTML]="thisStep.header"></div>
                <div class="step-main-content">
                  <div class="step-wrapper">
                    <div class="form-inner-block">

                      <div class="form-attributes" *ngIf="!minFields">
                        <section class="checkbox-children-section min-fields-error">
                          {{minFieldsError}}
                        </section>
                      </div>
                      <mat-accordion class="example-headers-align">
                        <div *ngFor=" let inputAttribute of inputAttributes; let attrIndex = index"
                          class="form-attributes">
                          <!--EXPANDABLE-->

                          <div *ngIf="inputAttribute.type == 'EXPANDABLE'"
                            class="checkbox-section {{(checkInputAttributeValid(inputAttribute)) ? 'valid-input-attribute': 'invalid-input-attribute'}}">

                            <mat-expansion-panel  [expanded]="false" class="overflow-pivot"
                              (opened)="accordionSetStep(attrIndex)" hideToggle multi="true">
                              <mat-expansion-panel-header class="accordion-header">
                                <!-- <mat-checkbox class="checkbox-parent" [name]="inputAttribute.name" [(ngModel)]="inputAttribute.selected"
                                  (change)="toggleExpandable($event, inputAttribute)">
                                  <span class="input-labels all-label">{{inputAttribute.label}}</span>
                                </mat-checkbox> -->
                                <!-- <span class="input-labels all-label">{{inputAttribute.label}}</span> -->
                                <span class="input-labels">{{inputAttribute.label}}</span>
                                <span class="accordion-success-image"></span>
                                <span class="expand-contract-image"></span>

                                <!-- <span class="accordion-success-image"></span>
                                <span class="expand-contract-image"></span> -->
                              </mat-expansion-panel-header>



                                <div class="checkbox-bottom-section">

                                  <ng-container *ngFor="let childInputAttr of inputAttribute.childAttribute">

                                    <div class="body-data-block" *ngIf="childInputAttr.type === 'CHECKBOX'">
                                        <section class="checkbox-children-section">
                                      <div class="input-attribute-label-exp">{{childInputAttr.label}}</div>
                                      <div >
                                      <mat-checkbox class="checkbox-parent {{childInputAttr.showSelectAll ? ' ' : ' hidden'}}"
                                      [(ngModel)]="childInputAttr.selected" [name]="childInputAttr.name"
                                      [disabled]="editSourceBoolean && storedTables.includes(inputAttribute.label)"
                                      (change)="onCheckBoxChangeAll($event, childInputAttr)">
                                      <span class="input-labels">Select All</span>
                                    </mat-checkbox>
                                      </div>
                                      <div class="expandable-checkbox-block" *ngIf="childInputAttr.type === 'CHECKBOX'">
                                        <mat-checkbox *ngFor="let pValue of childInputAttr.possibleValues; let pIndex = index"
                                          class="checkbox-children {{(pValue.length < 3) ? 'low-number': ''}}"
                                          [name]="childInputAttr.name" [(ngModel)]="pValue.selected"
                                          [ngModelOptions]="{standalone: true}"
                                          [disabled]="editSourceBoolean && storedTables.includes(inputAttribute.label)"
                                          (change)="onCheckBoxChanged(childInputAttr, pValue, $event, true)">
                                          <span class="input-labels all-label">{{pValue.group}}</span>
                                        </mat-checkbox>

                                      </div>
                                    </section>
                                    </div>

                                    <div *ngIf="childInputAttr.type === 'DROPDOWN'" class="body-data-block">
                                      <div class="input-attribute-label-exp">{{childInputAttr.label}}</div>
                                      <div>
                                        <ng-select [items]="childInputAttr.possibleValues" class="attribute-dropdown"
                                          [required]="childInputAttr.required" bindLabel="group" bindValue="value"
                                          name="{{childInputAttr.name}}" [(ngModel)]="childInputAttr.value"
                                          (change)="onDropDownValueChanged(childInputAttr,inputAttribute.name)" [clearable]="false"
                                          [clearOnBackspace]="false" [searchable]="false">

                                        </ng-select>
                                      </div>

                                    </div>

                                  </ng-container>

                                </div>


                            </mat-expansion-panel>
                          </div>

                          <!-- END-->
                          <div *ngIf="inputAttribute.type == 'CUSTOM_SELECT'">
                            <div class="input-attribute-help" [innerHtml]="inputAttribute.help"></div>
                            <h4 class="custom-select-header">Choose {{inputAttribute.label}} (maximum
                              {{inputAttribute.max}})</h4>
                            <ng-select class="custom" required placeholder="Select {{inputAttribute.label}}"
                              [items]="inputAttribute.possibleValues" [multiple]="true" bindLabel="value"
                              groupBy="group" [selectableGroup]="false" [closeOnSelect]="true" bindValue="value"
                              maxSelectedItems="{{inputAttribute.max}}"
                              (add)="onAddCustomValue($event, inputAttribute, attrIndex)"
                              (remove)="onRemoveCustomValue($event, inputAttribute, attrIndex)" [virtualScroll]="true"
                              name="{{(selectedDatasource.type === 'FRESHCHAT')?inputAttribute.name+attrIndex : inputAttribute.name}}"
                              [(ngModel)]="inputAttribute.selectedList" [clearSearchOnAdd]="true">
                            </ng-select>
                            <span class="input-attribute-description" [innerHtml]="inputAttribute.description"></span>
                            <div class="teaser" [innerHtml]="inputAttribute.teaser"></div>
                            <hr *ngIf="inputAttribute.description">
                          </div>
                          <button type="button" mat-button
                            *ngIf="selectedDatasource.type === 'FRESHCHAT' && (inputAttribute.ifAddButton)"
                            (click)="addFreshchatAttribute(inputAttribute, attrIndex)"
                            class="steps-browse-button">Add</button>
                          <button type="button" mat-button
                            *ngIf="selectedDatasource.type === 'FRESHCHAT' && (inputAttribute.ifRemoveButton)"
                            (click)="removeFreshchatAttribute(inputAttribute, attrIndex)"
                            class="steps-browse-button ml-10">Remove</button>

                          <div *ngIf="inputAttribute.type === 'DROPDOWN' && selectedDatasource.type !== 'ADJUST'" class="dropdown-type">
                            <div class="input-attribute-label">{{inputAttribute.label}} </div>
                            <div>
                              <!-- <ng-select [items]="inputAttribute.possibleValues" class="attribute-dropdown custom"
                                [required]="inputAttribute.required" bindLabel="value" bindValue="value"
                                name="{{inputAttribute.name}}" [(ngModel)]="inputAttribute.value"
                                (change)="onDropDownValueChanged(inputAttribute)" [clearable]="false"
                                [clearOnBackspace]="false" [searchable]="false">

                                <span class="input-attribute-description"
                                  [innerHtml]="inputAttribute.description"></span>

                              </ng-select> -->

                              <ng-select [(ngModel)]="inputAttribute.value" name="{{inputAttribute?.name}}" (change)="onDropDownValueChanged(inputAttribute)"
                                [clearable]="false" [clearOnBackspace]="false" [multiple]="inputAttribute?.multiselect" [searchable]="false" class="attribute-dropdown" [readonly]="editWarehouseBoolean && !inputAttribute?.ifEditable || (inputAttribute?.label === 'Optional Key Elements' && getValueFromDependentAttr())"
                                 [required]="inputAttribute?.required || ((selectedDatawarehouse?.type === 'AMAZONS3' || selectedDatawarehouse?.type === 'AzureOneLake' || selectedDatawarehouse?.type === 'AzureDataLake') && inputAttribute?.name === 'optionalKeyElements' && inputAttributes[inputAttributes?.length-1]?.name === 'needTimestampElements' && inputAttributes[inputAttributes?.length-1]?.value === 'Yes')" appearance="outline">
                                <ng-option *ngFor="let p of inputAttribute?.possibleValues" [value]="p.value" > <span class="input-option"> {{p.value}} </span>

                                  <span class="beta-label">
                                    <span *ngIf="p.beta" class="beta-icon Roboto font-weight-bold text-gray-600 d-flex items-center justify-center">BETA</span>
                                  </span>
                                </ng-option>
                              </ng-select>
                            </div>

                            <div class="input-attribute-help" [innerHtml]="inputAttribute.help"></div>
                          </div>
                          <div class="input-attribute-help" *ngIf="(selectedDatawarehouse?.type === 'GCS' || selectedDatawarehouse?.type === 'AMAZONS3' || selectedDatawarehouse?.type === 'AzureOneLake' || selectedDatawarehouse?.type === 'AzureDataLake') && inputAttribute.name === 'optionalKeyElements'">
                            Your file structure will look like: <b>{{getPath()}} </b>
                          </div>

                          <div *ngIf="inputAttribute.type === 'DROPDOWN' && selectedDatasource.type === 'ADJUST'">
                              <div class="input-attribute-label">{{inputAttribute.label}}</div>
                              <div>
                                <ng-select [items]="inputAttribute.possibleValues" class="attribute-dropdown adjust-spe-width"
                                  [required]="inputAttribute.required" bindLabel="group" bindValue="value"
                                  name="{{inputAttribute.name}}" [(ngModel)]="inputAttribute.value"
                                  (change)="onDropDownValueChanged(inputAttribute)" [clearable]="false"
                                  [clearOnBackspace]="true" [searchable]="true">
                                  <span class="input-attribute-description"
                                    [innerHtml]="inputAttribute.description"></span>

                                </ng-select>
                              </div>

                              <div class="input-attribute-help" [innerHtml]="inputAttribute.help"></div>
                            </div>

                          <div *ngIf="inputAttribute.type == 'CUSTOM_TABLE'">
                            <div class="custom-table" #customTable>

                              <table mat-table [dataSource]="customTableDataSource" class="mat-elevation-z8">
                                <ng-container matColumnDef="name">
                                  <th mat-header-cell *matHeaderCellDef> {{inputAttribute.name}} </th>
                                  <td mat-cell *matCellDef="let element;index as customIndex;"> {{element.name}} </td>
                                </ng-container>

                                <!-- Name Column -->
                                <ng-container matColumnDef="customColumnAlias">
                                  <th mat-header-cell *matHeaderCellDef> {{inputAttribute.customColumnAlias}} </th>
                                  <td mat-cell *matCellDef="let element;index as customIndex;">

                                    <mat-form-field>
                                      <input matInput type="text" name="{{element.customColumnAlias}}"
                                        #touchedText="ngModel" placeholder="Enter"
                                        [(ngModel)]="element.customColumnAlias" [ngModelOptions]="{standalone: true}"
                                        (ngModelChange)="onCustomAliasChange(element, inputAttribute.childAttribute)"
                                        [maxlength]="element.maxLength" [required]="true"
                                        [disabled]="!((!editSourceBoolean && !element.editCustomColumn) || (editSourceBoolean && element.editCustomColumn))">
                                    </mat-form-field>

                                  </td>
                                </ng-container>

                                <!-- Weight Column -->
                                <ng-container matColumnDef="customColumnDefaultType">
                                  <th mat-header-cell *matHeaderCellDef> {{inputAttribute.customColumnDefaultType}}
                                  </th>
                                  <td mat-cell *matCellDef="let element;index as customIndex;">
                                    {{element.customColumnDefaultType}} </td>
                                </ng-container>

                                <!-- Symbol Column -->
                                <ng-container matColumnDef="customColumnUserDefined">
                                  <th mat-header-cell *matHeaderCellDef> {{inputAttribute.customColumnUserDefined}}
                                  </th>
                                  <td mat-cell *matCellDef="let element;index as customIndex;">
                                    <ng-select [items]="element.possibleValues" class="custom-table-dropdown"
                                      [required]="element.required" bindLabel="group" bindValue="group" placeholder=""
                                      name="{{element.name}}" [(ngModel)]="element.customColumnUserDefined"
                                      [clearable]="false" [clearOnBackspace]="false"
                                      (change)="onCustomDataTypeChange(element, inputAttribute.childAttribute)"
                                      [disabled]="!((!editSourceBoolean && !element.editCustomColumn) || (editSourceBoolean && element.editCustomColumn))">
                                    </ng-select>
                                  </td>
                                </ng-container>

                                <tr mat-header-row
                                  *matHeaderRowDef="['name', 'customColumnAlias', 'customColumnDefaultType', 'customColumnUserDefined']; sticky: true">
                                </tr>
                                <tr mat-row
                                  *matRowDef="let row; columns: ['name', 'customColumnAlias', 'customColumnDefaultType', 'customColumnUserDefined'];">
                                </tr>
                              </table>
                            </div>
                            <button type="button" mat-button *ngIf="editSourceBoolean && customColumneditableBoolean"
                              (click)="addCustomColumn(inputAttribute)" class="steps-browse-button">Add a
                              Column</button>
                          </div>

                          <div *ngIf="inputAttribute.type == 'TEXT' && inputAttribute.label !== 'ListOfAttributes'">
                            <div class="input-attribute-label">{{inputAttribute.label}}</div>
                            <mat-form-field class="integration-name-mat-field">
                              <input matInput type="text"
                                name="{{(selectedDatasource.type === 'FRESHCHAT')?inputAttribute.name+attrIndex:inputAttribute.name}}"
                                #touchedText="ngModel"
                                [disabled]="editWarehouseBoolean && !inputAttribute.ifEditable || ((disableAmazonRedshiftspecific && (inputAttribute.name === 'remoteSSHIP' || inputAttribute.name === 'remoteSSHUser') ) || ((inputAttribute.name == 'integrationName') && ((editSourceBoolean) || (editWarehouseBoolean) )))"
                                placeholder=" {{inputAttribute.label}}" [(ngModel)]="inputAttribute.value"
                                (ngModelChange)="onTextValueChange(inputAttribute)"
                                [maxlength]="inputAttribute.maxLength" [required]="inputAttribute.required"
                                pattern="{{(inputAttribute.name == 'integrationName') ? integrationNameRegex : ''}}">
                            </mat-form-field>

                            <div class="text-error-message"
                              *ngIf="( (selectedDatasource.type === 'FRESHCHAT' && ( inputAttribute.name === 'historicaltables' || inputAttribute.name === 'instanttables' ) ) && (touchedText.touched  && !validationSuccess(inputAttribute.value)))">
                              Table Name can have only letters, numbers or an underscore( _ ) allowed.No spaces
                              allowed. Cannot have two consecutive underscores. Cannot start or end with an underscore.
                            </div>
                            <div class="text-error-message" *ngIf="inputAttribute.errorMessage">
                              {{inputAttribute.errorMessage}}
                            </div>

                            <span class="input-attribute-description" [innerHtml]="inputAttribute.description"></span>
                            <div class="input-attribute-help" [innerHtml]="inputAttribute.help"></div>
                            <div class="text-error-message"
                              *ngIf="touchedText.touched && inputAttribute.name == 'integrationName' && !validationSuccess(inputAttribute.value)">
                              Integration Name can have only letters, numbers or an underscore( _ ) allowed.No spaces
                              allowed. Cannot have two consecutive underscores. Cannot start or end with an underscore.
                            </div>
                          </div>

                          <div *ngIf="inputAttribute.type == 'PASSWORD'">
                            <div class="input-attribute-label">{{inputAttribute.label}}</div>
                            <mat-form-field class="integration-name-mat-field">
                              <input matInput type="password" name="{{inputAttribute.name}}"
                                placeholder=" {{inputAttribute.label}}" [(ngModel)]="inputAttribute.value"
                                (ngModelChange)="onTextValueChange(inputAttribute)"
                                [disabled]="(inputAttribute.name === 'remoteSSHPassphrase' && disableAmazonRedshiftspecific)"
                                [maxlength]="inputAttribute.maxLength" [required]="inputAttribute.required">
                            </mat-form-field>
                            <span class="input-attribute-description" [innerHtml]="inputAttribute.description"></span>
                            <div class="input-attribute-help" [innerHtml]="inputAttribute.help"></div>
                          </div>

                          <div class="p-b" *ngIf="dateOrHistoryCheckbox && checkboxDisplayIndex == attrIndex">
                            <div class="input-attribute-label p-b">History</div>
                          </div>

                          <div
                            *ngIf="!pushenagehistorydisable && inputAttribute.type == 'INTEGER' || inputAttribute.type == 'FLOAT'">
                            <div class="input-attribute-label"
                              [hidden]="(dateOrHistoryCheckbox && (checkboxDisplayIndex == attrIndex))">
                              {{inputAttribute.label}}</div>

                            <mat-radio-button *ngIf="dateOrHistoryCheckbox && checkboxDisplayIndex == attrIndex"
                              class="p-r" value="history" (change)="switchBetweenDateAndHistory(inputAttribute,$event)"
                              [checked]="!editSourceBoolean || !editCheckedDate"></mat-radio-button>
                            <mat-form-field class="time-mat-form-field">
                              <label>
                                <input matInput (keyup)="stepDown(inputAttribute)" step="1" type="number"
                                  name="{{inputAttribute.name}}" [min]="inputAttribute.min" [max]="inputAttribute.max"
                                  [(ngModel)]="inputAttribute.value"
                                  (ngModelChange)="onNumberValueChange(inputAttribute)"
                                  [required]="inputAttribute.required"
                                  [disabled]="(inputAttribute.name === 'remoteSSHPort' && disableAmazonRedshiftspecific) || (((!editSourceBoolean) && !dateDiable && inputAttribute.name == 'history') || ((inputAttribute.name == 'history') && (editSourceBoolean)))">
                              </label>
                            </mat-form-field>
                            <span class="input-attribute-description" [innerHtml]="inputAttribute.description"></span>
                            <div class="input-attribute-help" [innerHtml]="inputAttribute.help"></div>


                          </div>
                          <!--CLIPBOARD FIELD -->

                          <div *ngIf="inputAttribute.type == 'CLIPBOARD'">
                            <div class="input-attribute-label">{{inputAttribute.label}}</div>
                            <mat-form-field class="integration-name-mat-field">
                              <input matInput type="text" name="{{inputAttribute.name}}" #touchedText="ngModel"
                                placeholder=" {{inputAttribute.label}}" [(ngModel)]="inputAttribute.value" readonly>

                            </mat-form-field>

                            <i matRipple class="material-icons copy-icon"
                              (click)="copyToClipBoard(inputAttribute.value)">
                              file_copy
                            </i>

                          </div>

                          <div *ngIf="!dateOrHistoryCheckbox && pushenagehistorydisable">
                            <div *ngIf="inputAttribute.type == 'INTEGER' || inputAttribute.type == 'FLOAT'">
                              <div class="input-attribute-label">{{inputAttribute.label}}</div>
                              <mat-form-field class="time-mat-form-field">
                                <label>
                                  <input matInput (keyup)="stepDown(inputAttribute)" step="1" type="number"
                                    name="{{inputAttribute.name}}" [min]="inputAttribute.min" [max]="inputAttribute.max"
                                    [(ngModel)]="inputAttribute.value"
                                    (ngModelChange)="onNumberValueChange(inputAttribute)"
                                    [required]="inputAttribute.required"
                                    [disabled]="(inputAttribute.name == 'history')">
                                </label>
                              </mat-form-field>
                              <span class="input-attribute-description" [innerHtml]="inputAttribute.description"></span>
                              <div class="input-attribute-help" [innerHtml]="inputAttribute.help"></div>
                            </div>
                          </div>

                          <!-- <div *ngIf="!dateOrHistoryCheckbox && !pushenagehistorydisable">
                            <div *ngIf="inputAttribute.type == 'INTEGER' || inputAttribute.type == 'FLOAT'">
                              <div class="input-attribute-label">{{inputAttribute.label}}</div>
                              <mat-form-field class="time-mat-form-field">
                                <label>
                                  <input matInput (keyup)="stepDown(inputAttribute)" step="1" type="number"
                                         name="{{inputAttribute.name}}" [min]="inputAttribute.min"
                                         [max]="inputAttribute.max" [(ngModel)]="inputAttribute.value"
                                         (ngModelChange)="onNumberValueChange(inputAttribute)"
                                         [required]="inputAttribute.required"
                                         [disabled]="(inputAttribute.name == 'history') && (editSourceBoolean)">
                                </label>
                              </mat-form-field>
                              <span  class="input-attribute-description" [innerHtml]="inputAttribute.description"></span>
                              <div class="input-attribute-help" [innerHtml]="inputAttribute.help"></div>
                            </div>
                          </div> -->

                          <div *ngIf="inputAttribute.type == 'INFO'">
                            <div>
                              <span class="input-labels" [innerHTML]="inputAttribute.label"></span>
                            </div>
                          </div>

                          <div
                            *ngIf="inputAttributes.length > 1 && !attrIndex && inputAttribute.type === 'CHECKBOX' && minFields && inputAttribute.label !== 'Tables'">
                            <mat-checkbox class="checkbox-parent {{inputAttribute.showSelectAll ? ' ' : ' hidden'}}"
                              [name]="inputAttribute.name" (change)="onCheckBoxChangeAllColumsInAllRows($event)">
                              <span class="input-labels all-label">Select All Columns For All Tables</span>
                            </mat-checkbox>
                          </div>
                          <div
                            *ngIf="selectedDatasource.type === 'ADWORDS' && attrIndex === adwordLabelTable && currentStep === 3">
                            <div>
                              <span class="input-labels adword-custom-labels">Tables</span>
                            </div>
                          </div>
                          <div
                            *ngIf="selectedDatasource.type === 'ADWORDS' && attrIndex === adwordLabelReport && currentStep === 3">
                            <div>
                              <span class="input-labels adword-custom-labels">Reports</span>
                            </div>
                          </div>

                          <div
                            class="checkbox-section {{(checkInputAttributeValid(inputAttribute)) ? 'valid-input-attribute': 'invalid-input-attribute'}}"
                            *ngIf="inputAttribute.type == 'CHECKBOX' && minFields">

                            <mat-expansion-panel [expanded]="accordionStepIndex === attrIndex" class="overflow-pivot"
                              (opened)="accordionSetStep(attrIndex)" hideToggle multi="true">
                              <mat-expansion-panel-header class="accordion-header">
                                <span class="input-labels">{{inputAttribute.label}}</span>
                                <span class="accordion-success-image"></span>
                                <span class="expand-contract-image"></span>
                              </mat-expansion-panel-header>
                              <div class="checkbox-select-all">
                                <mat-checkbox class="checkbox-parent {{inputAttribute.showSelectAll ? ' ' : ' hidden'}}"
                                  [(ngModel)]="inputAttribute.selected" [name]="inputAttribute.name"
                                  (change)="onCheckBoxChangeAll($event, inputAttribute)">
                                  <span class="input-labels">Select All</span>
                                </mat-checkbox>
                                <div *ngIf="inputAttribute.pivot"
                                  class="child-attribute-checkbox {{(inputAttribute.markChildAttribute && !(inputAttribute.childAttribute[0].value)) ? 'child-attribute-red': ''}}">
                                  <ng-select [items]="inputAttribute.childAttribute[0].possibleValues"
                                    class="pivot-replication-select"
                                    [required]="inputAttribute.childAttribute[0].required" bindLabel="group"
                                    bindValue="group" placeholder="Replication field"
                                    name="{{inputAttribute.childAttribute[0].name}}"
                                    [(ngModel)]="inputAttribute.childAttribute[0].value"
                                    (change)="onSelectValueChanged(inputAttribute.childAttribute[0], inputAttribute, $event)"
                                    [clearable]="false" [clearOnBackspace]="false">
                                  </ng-select>
                                  <!-- <div
                               class="{{(inputAttribute.markChildAttribute && !(inputAttribute.childAttribute[0].value)) ? 'show-child-attr-error': 'hide-this'}}">
                               Please select a replication field
                             </div> -->
                                </div>
                              </div>


                              <section class="checkbox-children-section">
                                <!--class="{{(inputAttribute.name == 'tables' && v.category != '' && catagoryTitleIndexes.includes(idx))?'checkbox-children-category':'checkbox-children'}} {{(inputAttribute.possibleValues.length < 3) ? 'low-number': ''}}"
                                  [ngClass]="{'highlight-table':inputAttribute.name == 'tables' && true}"
 ngModelOptions is required when checkbox is in a form to track ngmodel instance angular 7 [ngClass]="{'mat-checkbox-inner-container-table':inputAttribute.name == 'tables' && inputAttribute.category != undefined}" -->
                                <div class="checkbox-bottom-section">
                                  <ng-container *ngFor="let v of inputAttribute.possibleValues; let idx = index">
                                    <span class="input-labels category-label"
                                      *ngIf="inputAttribute.name == 'tables' && v.category != '' && catagoryTitleIndexes.includes(idx)">{{v.category}}</span>

                                    <mat-checkbox
                                      class="checkbox-children {{(inputAttribute.possibleValues.length < 3) ? 'low-number': ''}}"
                                      name="{{inputAttribute.name}}" [(ngModel)]="v.selected"
                                      (change)="onCheckBoxChanged(inputAttribute, v, $event, true)"
                                      [ngModelOptions]="{standalone: true}"
                                      [disabled]="( !(v.canSelect) || (v.disabled ||  v.group.endsWith('_NA')))">

                                      <div
                                        [ngClass]="{'highlight-table':inputAttribute.name == 'tables' && v.fullLoadSupported}"
                                        class="input-labels"
                                        title="{{selectedDatasource.type !== 'ZOHOCRM' || !(v.group.includes('_NA'))?v.group:v.group.split('_NA')[0]}}">
                                        <span>{{selectedDatasource.type !== 'ZOHOCRM' || !(v.group.includes('_NA'))?v.group:v.group.split('_NA')[0]}}</span>
                                      </div>
                                      <div
                                        *ngIf="(selectedDatasource.type !== 'AMAZONMWS' || selectedDatasource.type !== 'SNAPCHATADS') && (v.disabled && !(v.exclusionFields.length > 0))"
                                        class="marked-replication">Marked as replication
                                        field
                                      </div>

                                    </mat-checkbox>
                                    <div *ngIf="v.category=='Reports' && v.childAttribute.length>0">
                                      <div *ngFor=" let childAttribute of v.childAttribute;  let subattrIndex = index"
                                      class="form-attributes checkbox-children">
                                      <mat-checkbox class="input-attribute-label" *ngIf="!childAttribute.required" (change)="disableAllFilter(v,childAttribute)" [disabled]="!v.selected">
                                        {{childAttribute.label}}
                                      </mat-checkbox>
                                      <div *ngIf="childAttribute.type == 'DROPDOWN'">
                                          <div>
                                            <span class="input-attribute-description" *ngIf="childAttribute.required">{{childAttribute.label}} *</span>
                                              <ng-select *ngIf ="childAttribute.required" (change)="uniqueDropdown(v.group,$event,v,childAttribute)"
                                                        [(ngModel)]="childAttribute.value"
                                                        [disabled]="!(v.selected && childAttribute.required)"
                                                        [clearOnBackspace]="false" [clearable]="false"
                                                        [items]="childAttribute.possibleValues"
                                                        [searchable]="false"
                                                        bindLabel="value"
                                                        bindValue="value" class="attribute-dropdown"
                                                        [ngModelOptions]="{standalone: true}">
                                                        <span [innerHtml]="childAttribute.description"
                                                        class="input-attribute-description"></span>
                                                        <span class="input-attribute-description">{{childAttribute.help}}</span>
                                              </ng-select>
                                              <ng-select *ngIf ="!childAttribute.required" (change)="uniqueDropdown(v.group,$event,v,childAttribute)"
                                                        [(ngModel)]="childAttribute.value"
                                                        [disabled]="!(v.selected && childAttribute.selected)"
                                                        [clearOnBackspace]="false" [clearable]="false"
                                                        [items]="childAttribute.possibleValues"
                                                        [searchable]="false"
                                                        bindLabel="value"
                                                        bindValue="value" class="attribute-dropdown"
                                                        [ngModelOptions]="{standalone: true}"
                                              >
                                                  <span [innerHtml]="childAttribute.description"
                                                        class="input-attribute-description"></span>
                                                  <span class="input-attribute-description">{{childAttribute.help}}</span>

                                              </ng-select>
                                          </div>
                                      </div>
                                      <div *ngIf="childAttribute.type == 'CUSTOM_SELECT'">
                                        <ng-select class="custom" *ngIf="childAttribute.name=='report_dimension'" required placeholder="Select {{childAttribute.label}}"
                                        [items]="childAttribute.possibleValues" [multiple]="true" bindLabel="value"
                                        [selectableGroup]="true" groupBy="group" [closeOnSelect]="true" bindValue="value"
                                        [maxSelectedItems]="200"
                                        [virtualScroll]="true" name="childAttribute.value"
                                        [clearSearchOnAdd]="true"
                                        name="{{v.group+childAttribute.name +childAttribute.index}}"
                                        [ngModel]="childAttribute.selectedList"
                                        [disabled]="!(v.selected && childAttribute.selected)"
                                        (add)="uniqueDropdown(v.group,$event,v,childAttribute)"
                                        ></ng-select>
                                        <ng-select class="custom" *ngIf="childAttribute.label=='Metrics' && !checkIfreportDimension(v)" required placeholder="Select {{childAttribute.label}}"
                                        [items]="childAttribute.possibleValues" [multiple]="true" bindLabel="value"
                                        [selectableGroup]="false" [closeOnSelect]="true" bindValue="value"
                                        [maxSelectedItems]="200"
                                        [virtualScroll]="true" name="childAttribute.value"
                                        [clearSearchOnAdd]="true"
                                        name="{{v.group+childAttribute.index}}"
                                        [ngModel]="childAttribute.selectedList"
                                        [disabled]="!v.selected"
                                        (add)="onsnapchatadsTableAttributeValue($event, childAttribute,v.group)"
                                        (remove)="removesnapchatTableAttributeValues($event, childAttribute,v.group)"
                                        (clear)="clearSnapchatadsTableAttributes($event, childAttribute,v.group)"
                                        ></ng-select>
                                        <ng-select class="custom" *ngIf="childAttribute.label=='Dimension Metrics' && checkIfreportDimension(v)" required placeholder="Select {{childAttribute.label}}"
                                        [items]="childAttribute.possibleValues" [multiple]="true" bindLabel="value"
                                        [selectableGroup]="false" [closeOnSelect]="true" bindValue="value"
                                        [maxSelectedItems]="200"
                                        [virtualScroll]="true" name="childAttribute.value"
                                        [clearSearchOnAdd]="true"
                                        name="{{v.group+childAttribute.index}}"
                                        [ngModel]="childAttribute.selectedList"
                                        [disabled]="!v.selected"
                                        (add)="onsnapchatadsTableAttributeValue($event, childAttribute,v.group)"
                                        (remove)="removesnapchatTableAttributeValues($event, childAttribute,v.group)"
                                        (clear)="clearSnapchatadsTableAttributes($event, childAttribute,v.group)"
                                        ></ng-select>
                                      <span class="input-attribute-description"
                                        [innerHtml]="childAttribute.description"></span>
                                      <div class="teaser" [innerHtml]="childAttribute.teaser"></div>
                                      <hr *ngIf="childAttribute.description">
                                      </div>
                                  </div>
                                    </div>
                                  </ng-container>

                                  <div *ngIf="minFields && !inputAttribute.showSelectAll">
                                    <div class="form-attributes"
                                      *ngFor=" let childAttribute of inputAttribute.childAttribute; let subattrIndex = subindex">
                                      <div *ngIf="childAttribute.possibleValues.length>0">
                                        <span
                                          class="input-labels subinputattribue-title">{{childAttribute.label}}</span>
                                        <mat-checkbox class="checkbox-children"
                                          *ngFor="let svs of childAttribute.possibleValues"
                                          name="{{childAttribute.name + '.' + svs.group}}"
                                          [(ngModel)]="isColumnSelected(inputAttribute,svs).selected"
                                          (change)="onCheckBoxChanged(inputAttribute, svs, $event, false)"
                                          [ngModelOptions]="{standalone: true}" [disabled]="svs.disabled">
                                          <div class="input-labels" title="{{svs.group}}">{{svs.group}}</div>
                                          <div *ngIf="svs.disabled && !(svs.exclusionFields.length > 0)">Marked as
                                            replication field</div>
                                        </mat-checkbox>
                                      </div>

                                    </div>
                                  </div>

                                </div>
                              </section>
                            </mat-expansion-panel>
                          </div>

                          <div *ngIf="inputAttribute.type == 'FILE'">
                            <div class="input-attribute-label">{{inputAttribute.label}}</div>

                            <input type="file" accept="{{inputAttribute.fileType}}" [id]="inputAttribute.name" *ngIf="!(inputAttribute.name.includes('json') && selectedDatawarehouse.type === 'BIGQUERY')"
                              [(ngModel)]="inputAttribute.value" (change)="uploadFile($event, inputAttribute)"
                              name="inputAttribute.name" hidden>

                            <input type="file" accept="{{inputAttribute.fileType}}" [id]="inputAttribute.name" *ngIf="(inputAttribute.name.includes('json') && selectedDatawarehouse.type === 'BIGQUERY')"
                              [(ngModel)]="inputAttribute.value" (change)="uploadFileToApi($event, inputAttribute)"
                              name="inputAttribute.name" hidden>

                            <button type="button" mat-button
                              [disabled]="inputAttribute.name === 'remoteSSHKey' && disableAmazonRedshiftspecific"
                              (click)="clickFileInput(inputAttribute)" class="steps-browse-button">Choose</button>
                            <span class="browse-file-name">{{inputAttribute.fileName}}</span>
                            <!-- <input hidden type="file" #imgFileInput (change)="previewImage($event)"/> -->


                            <span class="input-attribute-description" [innerHtml]="inputAttribute.description"></span>
                            <div class="input-attribute-help" [innerHtml]="inputAttribute.help"></div>
                          </div>


                          <div *ngIf="inputAttribute.type == 'RADIO'">
                            <div class="input-attribute-label">{{inputAttribute.label}} </div>

                            <section>
                              <mat-radio-group name="{{inputAttribute.name}}" [required]="inputAttribute.required"
                                [(ngModel)]="inputAttribute.value" [disabled]="editWarehouseBoolean"
                                (change)="onRadioValueChanged(inputAttribute)">
                                <mat-radio-button class="dynamic-radio-buttons"
                                  *ngFor="let value of inputAttribute.possibleValues" [value]="value.value">
                                  <!-- DONT Chnage this to value.value -->
                                  <span class="input-labels">{{value.group}} </span>
                                </mat-radio-button>
                              </mat-radio-group>
                            </section>
                          </div>
                          <div *ngIf="inputAttribute.type == 'DATEPICKER'">
                            <div [hidden]="dateOrHistoryCheckbox" class="input-attribute-label">{{inputAttribute.label}}
                            </div>
                            <div *ngIf="displayName !='PushEngage'">

                              <mat-radio-button *ngIf="dateOrHistoryCheckbox" class="p-r history-radio" value="date"
                                (change)="switchBetweenDateAndHistory(inputAttribute,$event)"
                                [checked]="editCheckedDate"></mat-radio-button>
                              <mat-form-field>
                                <input matInput [matDatepicker]="picker" id="id-name" name="{{inputAttribute.name}}"
                                  placeholder="Choose a date" [(ngModel)]="inputAttribute.value"
                                  [required]="inputAttribute.required" [disabled]="editSourceBoolean || dateDiable"
                                  (click)="picker.open()" [max]="minDateFilter"
                                  (dateChange)="onTextValueChange(inputAttribute)">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker name="{{inputAttribute.name}}"
                                  [(ngModel)]="inputAttribute.value" ngDefaultControl></mat-datepicker>
                              </mat-form-field>

                              <span class="input-attribute-description" [innerHtml]="inputAttribute.description"></span>
                              <div class="input-attribute-help" [innerHtml]="inputAttribute.help"></div>

                            </div>

                            <!-- <mat-form-field> -->
                            <div *ngIf="!dateOrHistoryCheckbox && displayName =='PushEngage'">
                              <mat-form-field>
                                <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="picker"
                                  name="{{inputAttribute.name}}" placeholder="Choose a date"
                                  [(ngModel)]="inputAttribute.value" (dateChange)="onTextValueChange(inputAttribute)">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker name="{{inputAttribute.name}}"
                                  [(ngModel)]="inputAttribute.value" ngDefaultControl></mat-datepicker>
                              </mat-form-field>
                              <span class="input-attribute-description" [innerHtml]="inputAttribute.description"></span>
                              <div class="input-attribute-help" [innerHtml]="inputAttribute.help"></div>
                            </div>
                            <!-- <div *ngIf="!dateOrHistoryCheckbox && displayName !='PushEngage'">
                                  <mat-form-field>
                                  <input matInput [matDatepicker]="picker"  name = "{{inputAttribute.name}}" placeholder="Choose a date" [(ngModel)]="inputAttribute.value" (dateChange)="onTextValueChange(inputAttribute)" >
                                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                  <mat-datepicker #picker name = "{{inputAttribute.name}}" [(ngModel)]="inputAttribute.value" ngDefaultControl></mat-datepicker>
                                  </mat-form-field>
                                  <span  class="input-attribute-description" [innerHtml]="inputAttribute.description"></span>
                                  <div class="input-attribute-help" [innerHtml]="inputAttribute.help"></div>
                                </div> -->

                            <!-- </mat-form-field> -->


                          </div>

                          <div *ngIf="inputAttribute.type == 'EMAIL'">
                            <div class="input-attribute-label">{{inputAttribute.label}}</div>
                            <mat-form-field class="integration-name-mat-field">
                              <input matInput type="email" name="{{inputAttribute.name}}" #email="ngModel"
                                placeholder=" {{inputAttribute.label}}" [(ngModel)]="inputAttribute.value"
                                (ngModelChange)="onTextValueChange(inputAttribute)"
                                [maxlength]="inputAttribute.maxLength.toString()" [required]="inputAttribute.required">
                            </mat-form-field>
                            <span class="input-attribute-description" [innerHtml]="inputAttribute.description"></span>
                            <div class="input-attribute-help" [innerHtml]="inputAttribute.help"></div>
                          </div>
                        </div>
                        <div *ngFor=" let gainputAttribute of gaInputAttributes; let attrIndex = index"
                          class="form-attributes">
                          <div *ngIf="gainputAttribute.tableName.type == 'TEXT'">
                            <div class="input-attribute-label">{{gainputAttribute.tableName.label}}</div>
                            <mat-form-field class="ga-table-name-mat-field">
                              <input matInput type="text" name="{{gainputAttribute.table}}" #touchedText="ngModel"
                                [disabled]="(editSourceBoolean) && !gainputAttribute.created"
                                placeholder=" {{gainputAttribute.tableName.label}}" [(ngModel)]="gainputAttribute.table"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="onChangeInGaTableValue(gainputAttribute,gainputAttribute.tableName)"
                                [maxlength]="gainputAttribute.tableName.maxLength.toString()"
                                [required]="gainputAttribute.tableName.required" pattern="{{integrationNameRegex}}">
                            </mat-form-field>
                            <div class="text-error-message"
                              *ngIf="touchedText.touched  && !validationSuccess(gainputAttribute.table)">
                              Table Name can have only letters, numbers or an underscore( _ ) allowed.No spaces
                              allowed. Cannot have two consecutive underscores. Cannot start or end with an underscore.
                            </div>
                            <div class="text-error-message" *ngIf="gainputAttribute.errorMessage">
                              {{gainputAttribute.errorMessage}}
                            </div>
                          </div>
                          <div *ngIf="gainputAttribute.dimensions.type == 'CUSTOM_SELECT'">
                            <div class="input-attribute-help" [innerHtml]="gainputAttribute.dimensions.help"></div>
                            <h4 class="custom-select-header">Choose {{gainputAttribute.dimensions.label}} (maximum
                              {{gainputAttribute.dimensions.max}})</h4>
                            <ng-select class="custom" required
                              placeholder="Select {{gainputAttribute.dimensions.label}}"
                              [items]="gainputAttribute.dimensions.possibleValues" [multiple]="true" bindLabel="value"
                              groupBy="group" [selectableGroup]="false" [closeOnSelect]="true" bindValue="value"
                              [maxSelectedItems]="gainputAttribute.dimensions.max"
                              (add)="onGaTableAttributeValue($event, gainputAttribute,gainputAttribute.dimensions,gainputAttribute.tableName.value)"
                              (remove)="removeGaTableAttributeValues($event, gainputAttribute,gainputAttribute.dimensions,gainputAttribute.tableName.value)"
                              [virtualScroll]="true"
                              (clear)="clearGaTableAttributes($event,gainputAttribute,gainputAttribute.dimensions,gainputAttribute.tableName.value)"
                              name="{{gainputAttribute.dimensions.name+gainputAttribute.index}}"
                              [ngModel]="gainputAttribute.dimensionselectedList" [clearSearchOnAdd]="true"
                              [disabled]="!gainputAttribute.table">
                            </ng-select>
                            <span class="input-attribute-description"
                              [innerHtml]="gainputAttribute.dimensions.description"></span>
                            <div class="teaser" [innerHtml]="gainputAttribute.dimensions.teaser"></div>
                            <hr *ngIf="gainputAttribute.dimensions.description">
                          </div>
                          <div *ngIf="gainputAttribute.metrics.type == 'CUSTOM_SELECT'">
                            <div class="input-attribute-help" [innerHtml]="gainputAttribute.metrics.help"></div>
                            <h4 class="custom-select-header">Choose {{gainputAttribute.metrics.label}} (maximum
                              {{gainputAttribute.metrics.max}})</h4>
                            <ng-select class="custom" required placeholder="Select {{gainputAttribute.metrics.label}}"
                              [items]="gainputAttribute.metrics.possibleValues" [multiple]="true" bindLabel="value"
                              groupBy="group" [selectableGroup]="false" [closeOnSelect]="true" bindValue="value"
                              [maxSelectedItems]="gainputAttribute.metrics.max"
                              (add)="onGaTableAttributeValue($event, gainputAttribute,gainputAttribute.metrics,gainputAttribute.tableName.value)"
                              (remove)="removeGaTableAttributeValues($event, gainputAttribute,gainputAttribute.metrics,gainputAttribute.tableName.value)"
                              [virtualScroll]="true" name="{{gainputAttribute.metrics.name+gainputAttribute.index}}"
                              [ngModel]="gainputAttribute.metricselectedList" [clearSearchOnAdd]="true"
                              [disabled]="!gainputAttribute.table"
                              (clear)="clearGaTableAttributes($event,gainputAttribute,gainputAttribute.metrics,gainputAttribute.tableName.value)">
                            </ng-select>
                            <span class="input-attribute-description"
                              [innerHtml]="gainputAttribute.metrics.description"></span>
                            <div class="teaser" [innerHtml]="gainputAttribute.metrics.teaser"></div>
                            <hr *ngIf="gainputAttribute.metrics.description">
                          </div>
                          <button type="button" mat-button *ngIf="attrIndex==gaInputAttributes.length-1"
                            (click)="addGaAttribute(gainputAttribute)" class="steps-browse-button">Add</button>
                          <button type="button" mat-button *ngIf="attrIndex>=0"
                            (click)="removeGaAttribute(gainputAttribute)"
                            class="steps-browse-button ml-10">Remove</button>
                        </div>

                        <div *ngFor="let gscInputAttribute of gscInputAttributes.iterableData let attrIndex = index"
                          class="form-attributes">

                          <div class="checkbox-section"
                            *ngIf="attrIndex === 0 && gscInputAttributes.tableCheck.type === 'CHECKBOX'">

                            <mat-expansion-panel [expanded]="accordionStepIndex === attrIndex" class="overflow-pivot"
                              (opened)="accordionSetStep(attrIndex)" hideToggle multi="true">
                              <mat-expansion-panel-header class="accordion-header">
                                <span class="input-labels">{{gscInputAttributes.tableCheck.label}}</span>
                                <span class="accordion-success-image"></span>
                                <span class="expand-contract-image"></span>
                              </mat-expansion-panel-header>
                              <div class="checkbox-select-all">


                              </div>



                              <section class="checkbox-children-section">

                                <div class="checkbox-bottom-section">
                                  <mat-checkbox
                                    class="checkbox-children {{(gscInputAttributes.tableCheck.possibleValues.length < 3) ? 'low-number': ''}}"
                                    *ngFor="let v of gscInputAttributes.tableCheck.possibleValues"
                                    name="{{gscInputAttributes.tableCheck.name}}" [(ngModel)]="v.selected"
                                    (change)="onCheckBoxChanged(gscInputAttributes.tableCheck, v, $event, true)"
                                    [ngModelOptions]="{standalone: true}" [disabled]="v.disabled">
                                    <div
                                      [ngClass]="{'highlight-table':gscInputAttributes.tableCheck.name == 'tables' && v.fullLoadSupported}"
                                      class="input-labels" title="{{v.group}}">
                                      <span>{{v.group}}</span>
                                    </div>
                                    <div *ngIf="v.disabled && !(v.exclusionFields.length > 0)"
                                      class="marked-replication">Marked as replication
                                      field
                                    </div>
                                  </mat-checkbox>


                                </div>
                              </section>
                            </mat-expansion-panel>
                          </div>

                          <div *ngIf="gscInputAttribute.tableName.type === 'TEXT'">
                            <div class="input-attribute-label extra-margin">{{gscInputAttribute.tableName.label}} <span
                                class="label-span">(Please enter a table name and select the dimensions for the table
                                name.)</span> </div>

                            <mat-form-field class="gsc-table-name-mat-field">
                              <input matInput type="text" name="{{gscInputAttribute.table}}" #touchedText="ngModel"
                                [disabled]="(editSourceBoolean) && !gscInputAttribute.created"
                                placeholder=" {{gscInputAttribute.tableName.label}}"
                                [(ngModel)]="gscInputAttribute.table" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="onChangeInGscTableValue(gscInputAttribute,gscInputAttribute.tableName)"
                                [maxlength]="gscInputAttribute.tableName.maxLength"
                                [required]="gscInputAttribute.tableName.required" pattern="{{integrationNameRegex}}">
                            </mat-form-field>
                            <div class="text-error-message"
                              *ngIf="touchedText.touched  && !validationSuccess(gscInputAttribute.table)">
                              Table Name can have only letters, numbers or an underscore( _ ) allowed.No spaces
                              allowed. Cannot have two consecutive underscores. Cannot start or end with an underscore.
                            </div>
                            <ng-container *ngIf="['Admin', 'OrganizationAdmin'].includes(userDetails?.role) && selectedDatawarehouse.type === 'BIGQUERY' && !ifManagedBigQueryWarehouseIsCreated" >
                              <span class="or-sty" >OR</span>
                              <button
                                class="button-sty form-button-style step-next-button tooltip hover-tooltip tooltip-sm" mat-raised-button type="button" (click)="createManagedBigQuery()"
                                >
                                Create Managed BigQuery
                              </button>
                            </ng-container>
                            <div class="text-error-message" *ngIf="gscInputAttribute.errorMessage">
                              {{gscInputAttribute.errorMessage}}
                            </div>
                          </div>


                          <div *ngIf="gscInputAttribute.dimensions.type == 'CUSTOM_SELECT'">
                            <div class="input-attribute-help" [innerHtml]="gscInputAttribute.dimensions.help"></div>
                            <!-- <h4 class="custom-select-header">Choose {{gscInputAttribute.dimensions.label}} (maximum {{gscInputAttribute.dimensions.max}})</h4> -->
                            <h4>Choose Optional Dimensions (Selecting dimensions especially 'page' will result in data
                              loss due to sampling. Refer to our <a tabindex='-1'
                                href='https://docs.sarasanalytics.com/integrations/data-sources/saas-integrations/google-search-console'
                                target='_blank'> documention </a> for additional details)</h4>
                            <ng-select class="custom" placeholder="Select {{gscInputAttribute.dimensions.label}}"
                              [items]="gscInputAttribute.dimensions.possibleValues" [multiple]="true" bindLabel="value"
                              groupBy="group" [selectableGroup]="false" [closeOnSelect]="true" bindValue="value"
                              [maxSelectedItems]="gscInputAttribute.dimensions.max"
                              (add)="onGscTableAttributeValue($event, gscInputAttribute,gscInputAttribute.dimensions,gscInputAttribute.tableName.value)"
                              (remove)="removeGscTableAttributeValues($event, gscInputAttribute,gscInputAttribute.dimensions,gscInputAttribute.tableName.value)"
                              [virtualScroll]="true" [disabled]="!gscInputAttribute.table"
                              (clear)="clearGscTableAttributes($event,gscInputAttribute,gscInputAttribute.dimensions,gscInputAttribute.tableName.value)"
                              name="{{gscInputAttribute.dimensions.name+gscInputAttribute.index}}"
                              [ngModel]="gscInputAttribute.dimensionselectedList" [clearSearchOnAdd]="true">
                            </ng-select>
                            <span class="input-attribute-description"
                              [innerHtml]="gscInputAttribute.dimensions.description"></span>
                            <div class="teaser" [innerHtml]="gscInputAttribute.dimensions.teaser"></div>
                            <hr *ngIf="gscInputAttribute.dimensions.description">
                            <div class="extra-label">Daton will use the dimensions selected to extract data from Search
                              Console and load the data into the table name provided above.</div>
                          </div>

                          <button type="button" mat-button *ngIf="attrIndex==gscInputAttributes.iterableData.length-1"
                            (click)="addGscAttribute(gscInputAttribute)" class="steps-browse-button">Add</button>
                          <button type="button" mat-button *ngIf="attrIndex>=0"
                            (click)="removeGscAttribute(gscInputAttribute)"
                            class="steps-browse-button ml-10">Remove</button>
                        </div>
                      </mat-accordion>
                    </div>
                  </div>
                </div>

                <div class="input-labels text-error-message-one">
                <button class="input-labels text-error-message-one" *ngIf="(enableTestButtonForPermission() && displayMessage)"
                [disabled]="(!enableTestButtonForPermission() || !displayMessage)">{{errorMessagePermissionCheck}}
                  <p class="p-op-line1 font-size-error-message"><a href={{documentURL}} target="_blank">{{documentName}}</a></p>
                </button>
                </div>

                <div class="navigate-buttons-block" >

                  <div class="navigate-buttons-inner-block">
                    <button *ngIf="!(currentStep >= noOfPreLoginSteps + noOfPostLoginSteps) && minFields"
                      class="form-button-style step-next-button tooltip hover-tooltip tooltip-sm" mat-raised-button type="button" (click)="onSubmit()"
                      [disabled]="( checkEditWarehouseStepForward() && (!(integrationNameForm.form.valid) || !atleastOneFromAllSelectedAndAllFilesUploaded() || !minFields || sameIntegrationName || sametableName) ) || ((selectedDatawarehouse.type === 'GCS' || !editWarehouseBoolean) && enableTestButtonForPermission())">
                      {{(currentStep == noOfPreLoginSteps + noOfPostLoginSteps - 1) ? 'SUBMIT' : 'NEXT'}}

                      <div class="tooltip-section fade-in">
                        <div *ngIf="(enableTestButtonForPermission())" class="tooltip-body" >
                          {{(currentStep == noOfPreLoginSteps + noOfPostLoginSteps - 1) ? (enableTestButtonForPermission()) ?  integrationNameForm.form.valid ? 'Click "Test Setup" to test the setup before proceeding' : 'Select any value' : 'SUBMIT' : ''}}
                        </div>
                    </div>
                    </button>

                    <button
                      *ngIf="!(currentStep == 0 || currentStep >= noOfPreLoginSteps + noOfPostLoginSteps) && !backDisabled"
                      class="form-button-style step-back-button" mat-raised-button type="button" (click)="onBack()">BACK
                    </button>

                    <!-- <button *ngIf="userInputChanged" -->
                    <button class="form-button-style step-back-button" mat-raised-button type="button"
                      (click)="onCancel()">CANCEL
                    </button>

                    <button  class="form-button-style step-next-button" mat-raised-button type="button"
                    *ngIf="enableTestButtonForPermission()" (click)="checkPermission()" [disabled]="(!enableTestButtonForPermission() || !integrationNameForm.form.valid)">
                    Test Setup </button>

                  </div>
                </div>
              </div>

              <div class="loader-image" *ngIf="loader">
                <div class="loader-wrapper">
                  <img src="../assets/images/loading.svg">
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
